import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpRightFromSquare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.25 10C12.6562 10 13 10.3438 13 10.75V14.25C13 15.2188 12.1875 16 11.25 16H1.75C0.78125 16 0 15.2188 0 14.25V4.75C0 3.8125 0.78125 3 1.75 3H5.25C5.65625 3 6 3.34375 6 3.75C6 4.1875 5.65625 4.5 5.25 4.5H1.75C1.59375 4.5 1.5 4.625 1.5 4.75V14.25C1.5 14.4062 1.59375 14.5 1.75 14.5H11.25C11.375 14.5 11.5 14.4062 11.5 14.25V10.75C11.5 10.3438 11.8125 10 12.25 10ZM15.25 0C15.6562 0 16 0.34375 16 0.75V6C16 6.4375 15.6562 6.75 15.25 6.75C14.8125 6.75 14.5 6.4375 14.5 6V2.5625L6.75 10.2812C6.625 10.4375 6.4375 10.5 6.25 10.5C6.03125 10.5 5.84375 10.4375 5.71875 10.2812C5.40625 10 5.40625 9.53125 5.71875 9.25L13.4375 1.5H10C9.5625 1.5 9.25 1.1875 9.25 0.75C9.25 0.34375 9.5625 0 10 0H15.25Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgArrowUpRightFromSquare);
export { ForwardRef as ReactComponent };
